import logo from './logo.svg';
import './App.css';

import awsconfig from './aws-exports';
import { Amplify, Auth, Hub } from 'aws-amplify';
import { useEffect, useState } from 'react';
import Dashboard from './screens/Dashboard';
import SignInScreen from './screens/SignInScreen';

Amplify.configure(awsconfig);

function App() {
  const [user, setUser] = useState(undefined);

  const checkUser = async () => {
    console.log('checking');
    try {
        const authUser = await Auth.currentAuthenticatedUser({bypassCache: true});
        setUser(authUser);
    } catch (e) {
        setUser(null);
    }
  }

  useEffect(() => {
    checkUser();
    const listener = (data) => {
      if (data.payload.event === 'signIn' || data.payload.event === 'signOut') {
          console.log(`${data.payload.event} event just occurred`);
          checkUser();
      }
    };

    Hub.listen('auth', listener);
    return () => Hub.remove('auth', listener);
  }, [])

  if (user === undefined) return <h1>Loading...</h1>
  return (
    <div className="App">
      {user ? 
        <Dashboard user={user} /> :
        <SignInScreen />
      }
    </div>
  );
}

export default App;
